module.exports = __webpack_public_path__ + "img/79.14697e0.jpg";